export const JUST_BASH_3_ROOT_EXPORTS = [
  "Bash",
  "BashTransformPipeline",
  "CommandCollectorPlugin",
  "DefenseInDepthBox",
  "EMPTY_BYTES",
  "InMemoryFs",
  "MountableFs",
  "NetworkAccessDeniedError",
  "OverlayFs",
  "ReadWriteFs",
  "RedirectNotAllowedError",
  "Sandbox",
  "SandboxCommand",
  "SecurityViolationError",
  "SecurityViolationLogger",
  "TeePlugin",
  "TooManyRedirectsError",
  "bytesOutput",
  "createConsoleViolationCallback",
  "decodeBytesToUtf8",
  "defineCommand",
  "encodeUtf8ToBytes",
  "getCommandNames",
  "getJavaScriptCommandNames",
  "getNetworkCommandNames",
  "getPythonCommandNames",
  "latin1FromBytes",
  "parse",
  "serialize",
  "stdoutAsBytes",
  "stdoutKind",
  "textOutput",
  "unsafeBytesFromLatin1",
] as const;

export const JUST_BASH_3_COMMAND_NAMES = [
  "echo", "cat", "printf", "ls", "mkdir", "rmdir", "touch", "rm",
  "cp", "mv", "ln", "chmod", "pwd", "readlink", "head", "tail",
  "wc", "stat", "grep", "fgrep", "egrep", "rg", "sed", "awk",
  "sort", "uniq", "comm", "cut", "paste", "tr", "rev", "nl",
  "fold", "expand", "unexpand", "strings", "split", "column",
  "join", "tee", "find", "basename", "dirname", "tree", "du",
  "env", "printenv", "alias", "unalias", "history", "xargs",
  "true", "false", "clear", "bash", "sh", "jq", "base64", "diff",
  "date", "sleep", "timeout", "seq", "expr", "md5sum", "sha1sum",
  "sha256sum", "file", "html-to-markdown", "help", "which", "tac",
  "hostname", "od", "gzip", "gunzip", "zcat", "tar", "yq", "xan",
  "sqlite3", "time", "whoami",
] as const;

export const JUST_BASH_3_NETWORK_COMMAND_NAMES = ["curl"] as const;
export const JUST_BASH_3_PYTHON_COMMAND_NAMES = ["python3", "python"] as const;
export const JUST_BASH_3_JAVASCRIPT_COMMAND_NAMES = ["js-exec", "node"] as const;
